import { useContext } from 'react';
import { UpsellBlockContext } from '../components/UpsellBlockContext/UpsellBlockContextProvider';

export function useUpsellBlock() {
  return useContext(UpsellBlockContext);
}
